export const selectReturnInvoicesProductFamily = state => state.data.returnInvoices.selectedProduct;
